export const get_user_roles_ByTenant = `
query getUserRolesByTenant($tenantId : String!,$role:String!){
    user_roles(where: { TenantId: {_eq: $tenantId}, Role: {_eq: $role}}){
        Id
        TenantId
        UserId
        Role
        DateStart
        DateEnd
        user {
            Username
            Email
            Name
            Surname
            Locale
            IsRespAntiRic
            IsActive
            IsDeleted
            IsBanned
            CreatedOn
            Cf
        }
    }
}`;
export const count_active_user_per_role =`
query CountUserRoles($role: String!,$tenantId:String!) {
    user_roles(where :{
        TenantId : {_eq:$tenantId},Role : {_eq:$role}, DateStart :{_lte:"TODAY"},
        _or : [{DateEnd : {_gt :"TODAY"}},{DateEnd :{_is_null:true}}]
    })
    {
        Id
        TenantId
        UserId
        Role
        DateStart
        DateEnd
        user {
            Username
            Email
            Name
            Surname
            Locale
            IsRespAntiRic
            IsActive
            IsDeleted
            IsBanned
            CreatedOn
            Cf
        }
    }
}`;
export const GET_USER_ROLES = `
	query GetUserRoles(		
		$tenantId: String!
		$aziendaId: Int!
	) {
		getUserRoles(			
			tenantId: $tenantId
			aziendaId: $aziendaId
		) {
			id
			tenantId
			userId
			role
			dateStart
			dateEnd
			aziendaId
            sosUserDateRegUif
		}
	}`;
export const GET_USER_ROLE_BY_ID = `
	query GetUserRoleById(
		$id: Int!
		$userId: String!
		$tenantId: String!
		$aziendaId: Int!
	) {
		getUserRoleById(
			id: $id
			userId: $userId
			tenantId: $tenantId
			aziendaId: $aziendaId
		) {
			id
			tenantId
			userId
			role
			dateStart
			dateEnd
			aziendaId
            sosUserDateRegUif
		}
	}`;
export const GET_USER_ROLES_DETAILS = `
	query GetUserRolesDetails(
		$tenantId: String!
		$aziendaId: Int!
		$userId: String!
		$targetUserId: String
	) {
		getUserRolesDetails(
			tenantId: $tenantId
			aziendaId: $aziendaId
			userId: $userId
			targetUserId: $targetUserId
		) {
            userId
            firstName
            surname
            email
            role
            roleStartDate
            roleEndDate
            status
		}
	}`;
